import React from 'react';
import { Typography, Box, Avatar, Chip, Paper } from '@mui/material';
import { getRoleColor, getRoleDisplayName } from './navItems';

/** Gebruikerskaart in de mobiele navigatielade: avatar, e-mail en rol. */
export default function NavDrawerUserInfo({ user, role }) {
  return (
    <Paper
      elevation={0}
      sx={{
        m: 2,
        p: 2,
        bgcolor: 'action.hover',
        borderRadius: 2,
        border: 1,
        borderColor: 'divider',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Avatar
          sx={{
            bgcolor: 'primary.main',
            width: 40,
            height: 40,
          }}
        >
          {user?.email?.charAt(0).toUpperCase()}
        </Avatar>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {user?.email}
          </Typography>
          <Chip
            label={getRoleDisplayName(role)}
            size="small"
            color={getRoleColor(role)}
            sx={{ mt: 0.5, fontSize: '0.75rem' }}
          />
        </Box>
      </Box>
    </Paper>
  );
}
